import React from 'react'
import styled from 'styled-components'

import nextArrow from '../../assets/addUserScreen/next-arrow.png'
import prevArrow from '../../assets/addUserScreen/prev-arrow.png'

import { fontSizeResponsive, mediaQ } from '../theme/mixins'

const PaginationContainer = styled.div`
  /* width: 28vw; */
  position: absolute;
  bottom: 10.4vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  left: 50px;

  ${mediaQ(
    'mobileAll',
    'position:absolute;z-index:3; background-image: linear-gradient(97deg, #fe0da0, #9e0dfe);bottom:0;width:100%;left:0;padding:10px;box-sizing:border-box;'
  )}

  ${mediaQ('desktopAll', 'left: 10%;')}
  ${mediaQ('ipad12', 'left: 25px;')}
  ${mediaQ('ipad10', 'left: 25px;')}
  ${mediaQ('ipad9', 'margin: left: 25px;')}
`
const PaginationArrow = styled.div`
  background: url('${(props) => (props.next ? nextArrow : prevArrow)}');
  background-size: contain;
  background-repeat: no-repeat;
  width: 12px;
  height: 15px;
`
const PaginationButtonContainer = styled.div`
  display: flex;
  align-items: center;
`
const PaginationButton = styled.button`
  border: none;
  outline: none;
  ${fontSizeResponsive(19)};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.79;
  letter-spacing: 0.95px;
  text-align: right;
  color: #ffffff;
  font-family: 'Open Sans';
  background: none;
  cursor: pointer;
  text-transform: uppercase;
  margin: 0 5px;

  ${mediaQ('mobileAll', 'font-size:12px;')}
`
const PaginationDotsContainer = styled.div`
  display: flex;
`
const PaginationDot = styled.div`
  background-color: black;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  background-color: ${(props) =>
    props.active ? 'white' : 'rgba(255, 255, 255, 0.5)'};
  margin: 0 10px;

  ${mediaQ('mobileAll', 'width:10px;height:10px;margin: 0 6px;')}
  ${mediaQ('mobileS', 'width:6px;height:6px;margin: 0 4px;')}

  ${mediaQ('ipad12', 'margin: 0 5px;')}
  ${mediaQ('ipad10', 'margin: 0 5px;')}
  ${mediaQ('ipad9', 'margin: margin: 0 5px;')}
`

const AboutYouPagination = ({ steps, activeStep, onNavButtonClick }) => {
  return (
    <PaginationContainer>
      <PaginationButtonContainer onClick={() => onNavButtonClick('prev')}>
        <PaginationArrow prev />
        <PaginationButton>Wróć</PaginationButton>
      </PaginationButtonContainer>
      <PaginationDotsContainer>
        {[...Array(steps)].map((e, i) => (
          <PaginationDot key={i} active={activeStep === i} />
        ))}
      </PaginationDotsContainer>
      <PaginationButtonContainer onClick={() => onNavButtonClick('next')}>
        <PaginationButton>Dalej</PaginationButton>
        <PaginationArrow next />
      </PaginationButtonContainer>
    </PaginationContainer>
  )
}

export default AboutYouPagination
